import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginUser } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../Store/authSlice";

const 
Login = () => {
    const navigate = useNavigate();

  const [email,setEmail] = useState("")
  const [password,setPassword] = useState("")
  const dispatch=useDispatch()

 

  const handleLogin =async  (e) => {

    e.preventDefault()

    if(!email || !password){
      alert("Please enter email and password")
      return
    }

    try {
       const res= await LoginUser({email,password})
    console.log(res);
    

   

    if(res.status===200){
      toast.success("Loggedin Successfully")
       dispatch(setCredentials({user:res.data.user,token:res.data.token}))
        navigate("/profile")
    }
    } catch (error) {
      console.log(error);
      
    }
   
    

    console.log("Login Data:",{email,password})



  }

  return (

    <>
      <h2>Login</h2>
      <p className="dd-auth-subtitle">
        Enter your credentials to access your account
      </p>

      <form className="dd-auth-form" onSubmit={handleLogin}>

        <label>Email *</label>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
        />

        <label>Password *</label>
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
        />

        <button className="dd-auth-submit" >Login</button>

      </form>
    </>

  );
};

export default Login;